import { FC, useState } from "react";
import { IAccordionProps } from "./types";
import classNames from "classnames";
import styles from "./AccordionLight.module.css";

const AccordionLight: FC<IAccordionProps> = ({
  isDisabled,
  header,
  subHeader,
  content,
  classNameContainer,
  classNameHeader,
  classNameContent,
  classNameSubHeader
}) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <article className={classNames(styles["accordion"], classNameContainer)}>
      <header className={classNames(styles["accordion__header"], classNameHeader)}>
        <a
          className={classNames(styles["accordion__button"], classNameHeader)}
          onClick={() => {
            if (isDisabled) return;
            setIsOpen(!isOpen);
          }}
        >
          {header(isOpen)}
        </a>
        <div className={classNames(styles["accordion__subheader"], classNameSubHeader)}>
          {subHeader && subHeader(isOpen)}
        </div>
      </header>
      {isOpen && (
        <section className={classNames(styles["accordion__content"], classNameContent)}>
          {content(isOpen)}
        </section>
      )}
    </article>
  );
};

export default AccordionLight;
